import React, { PropTypes } from 'react';
import { Field, reduxForm, SubmissionError, initialize } from 'redux-form';
import { Button } from 'react-bootstrap';
import axios from './../../constants/axios';
import alert from 'alertify.js';
import InputControl from './../FormTemplate/InputControl';
import SelectAsync from './../FormTemplate/SelectAsync';

class EditBrandForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         brand: {}
      };
   }

   componentDidMount() {
      const { id } = this.props.params;
      axios.get(`brands/getById/${id}`)
         .then((res) => {
            this.props.dispatch(initialize('editBrandForm', res.data));
            this.setState({
               brand: res.data
            });
         });
   }

   update = (values) => {
      const { id } = this.props.params;
      return axios.post(`brands/update/${id}`, values)
         .then((res) => {
            if (res.status === 204) {
               alert.success('Brand Updated');
               this.context.router.push('brand');
            } else {
               alert.error('Something Went Wrong. Call Rasel');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { brand } = this.state;
      const { handleSubmit, submitting, pristine, invalid } = this.props;
      return (
         <div>
            <h3>Edit Brand Form</h3>
            <form onSubmit={handleSubmit(this.update)} autoComplete="off" noValidate >
               <Field name="name" component={InputControl} type="text" label="Brand Name" />

               <Field name="manufacturer_id"
                      component={SelectAsync}
                      initial={[
                         { label: brand.manufacturer_name, value: brand.manufacturer_id }
                      ]}
                      link="manufacturers/searchByName" />
               <Button type="submit" bsStyle="success" block
                       disabled={submitting || pristine || invalid} >Update</Button>
            </form>
         </div>
      );
   }
}
EditBrandForm.propTypes = {
   handleSubmit: React.PropTypes.func,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   dispatch: PropTypes.func,
   params: PropTypes.object,
   id: PropTypes.number
};

EditBrandForm.contextTypes = {
   router: PropTypes.object.isRequired
};

EditBrandForm = reduxForm({ // eslint-disable-line
   form: 'editBrandForm'
})(EditBrandForm);

export default EditBrandForm;



/** WEBPACK FOOTER **
 ** ./src/components/Brand/EditBrandForm.js
 **/